
export const BACK_END_URL = 'https://office.strd.pro/api/v1/docx/';


export const API_AUTH = 'auth/web';

export const API_UPLOAD = 'files/upload';
